import React, { useEffect, useState } from "react";
import { FaCamera } from "react-icons/fa";
import { ErrorBags } from "../page/Teacher/TeacherInterface";

interface ProfileImageUploadProps {
  inputChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setErrorBags: React.Dispatch<React.SetStateAction<ErrorBags>>;
  imagestring?: string;
}

export default function ProfileImageUpload({
  inputChangeHandler,
  setFormData,
  setErrorBags,
  imagestring,
}: ProfileImageUploadProps) {
  const [image, setImage] = useState<string | null>(imagestring || null);
  const [imageFile, setImageFile] = useState<File | null>(null);

  useEffect(() => {
    if (imagestring) {
      setImage(imagestring);
    }
  }, [imagestring]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (!file) {
      setImage(null);
      setImageFile(null);
      setErrorBags((prevErrors) => ({
        ...prevErrors,
        profile_photo: "", // No error message if no file is selected
      }));
      return; // Exit early since file selection is optional
    }
    const validFileTypes = ["image/jpeg", "image/png"];
    if (!validFileTypes.includes(file.type)) {
      setErrorBags((prevErrors) => ({
        ...prevErrors,
        profile_photo: "Invalid file type. Only JPG and PNG files are allowed.",
      }));
      return;
    }
    const maxSize = 3 * 1024 * 1024;
    if (file.size > maxSize) {
      setErrorBags((prevErrors) => ({
        ...prevErrors,
        profile_photo: "File size exceeds 3MB. Please select a smaller file.",
      }));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result as string);
    };
    reader.readAsDataURL(file);

    setImageFile(file);
    setErrorBags((prevErrors) => ({
      ...prevErrors,
      profile_photo: "",
    }));
    inputChangeHandler(e);
  };

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files ? e.target.files[0] : null;

  //   if (!file) {
  //     setImage(null); // Clear the preview image
  //     setImageFile(null); // Clear the file
  //     setErrorBags((prevErrors) => ({
  //       ...prevErrors,
  //       profile_photo: "Please select a file.",
  //     }));
  //     return;
  //   }
  //   if (!file.type.startsWith("image/")) {
  //     setErrorBags((prevErrors) => ({
  //       ...prevErrors,
  //       profile_photo: "Please select a valid image file.",
  //     }));
  //     return;
  //   }

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     setImage(reader.result as string); // Set the image preview
  //   };
  //   reader.readAsDataURL(file);

  //   setImageFile(file); // Save the file to state
  //   setErrorBags((prevErrors) => ({
  //     ...prevErrors,
  //     profile_photo: "",
  //   }));
  //   inputChangeHandler(e); // Notify the parent component
  // };

  return (
    <div className="col-span-1 md:col-span-2">
      <label htmlFor="imageUpload" className="cursor-pointer">
        <div className="rounded-full w-32 h-32 bg-gray-200 flex items-center justify-center overflow-hidden">
          {image ? (
            <img
              src={image}
              alt="Profile"
              className="rounded-full w-32 h-32 object-cover"
            />
          ) : (
            <FaCamera className="text-gray-500 text-2xl" />
          )}
        </div>
        <input
          id="imageUpload"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleFileChange}
        />
      </label>
    </div>
  );
}
